import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'mapbox-gl/dist/mapbox-gl.css';

import { CssBaseline, ThemeProvider } from '@material-ui/core';
import { StylesProvider, jssPreset } from '@material-ui/styles';
import { create } from 'jss';
import jssExtend from 'jss-plugin-extend';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import App from './App';
import theme from './mui-theme';
import * as serviceWorker from './serviceWorker';
import store from './store';

const jss = create({
  plugins: [jssExtend(), ...jssPreset().plugins],
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <CssBaseline />
      <StylesProvider jss={jss}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </StylesProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
